import { t } from "@/i18n-js/instance";
import { ConfirmationCardLayout } from "./ConfirmationCardLayout";

export interface SpaceConfirmationCardProps {
  access?: string;
  name?: string;
  space_group?: string;
  type?: string;
}

export const SpaceConfirmationCard = ({
  name,
  space_group,
  type,
  access,
}: SpaceConfirmationCardProps) => (
  <ConfirmationCardLayout
    title={t("help_widget.copilot.confirmation_card.space_title")}
    attributes={[
      {
        label: t("help_widget.copilot.confirmation_card.name"),
        value: name,
      },
      {
        label: t("help_widget.copilot.confirmation_card.space_group"),
        value: space_group,
      },
      {
        label: t("help_widget.copilot.confirmation_card.type"),
        value: type,
      },
      {
        label: t("help_widget.copilot.confirmation_card.access"),
        value: access,
      },
    ]}
  />
);
